import { AfterContentChecked, Component, OnInit, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Observable } from 'rxjs/Observable';
import { TOKEN_PADRAO } from './app.constants';
import { AuthInterceptor } from './area-restrita/interceptor/auth.interceptor';
import { LoginService } from './area-restrita/login/service/login.service';
import * as ItemMenuActions from './area-restrita/shared/actions/item-menu.action';
import { ItemMenu } from './area-restrita/shared/dominios/item-menu';
import { SistemasLista } from './area-restrita/shared/dominios/sistemas-lista.modules';
import { GerenciamentoPermissoesModels } from './area-restrita/shared/models/gerenciamento-permissoes.model';
import { ValidarPermissaoFuncionalidadeService } from './area-restrita/shared/services/validar-permissao-funcionalidades.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [LoginService]
})
export class AppComponent implements OnInit, AfterContentChecked {

    @BlockUI() blockUi: NgBlockUI;


    mostrarMenu?: Boolean;
    mostrarLoginInput?: Boolean;

    mobileMenuActive: Boolean;

    menuClick: boolean;
    menuButtonClick: boolean;

    layoutStatic: boolean;

    gereciamentoPermissoes$: Observable<GerenciamentoPermissoesModels>;

    url: string;

    captchaKey: object;

    itemMenu$: Observable<ItemMenu[]>;
    sistemasLista: SistemasLista[] = [];
    sistemasListaAgrupados$: Observable<SistemasLista[]>;
    itensMenu: ItemMenu[] = [];


    constructor(
        private router: Router,
        private loginService: LoginService,
        private authInterceptor: AuthInterceptor,
        private store: Store<GerenciamentoPermissoesModels>,
        public validarPermissaoFuncionalidadeService: ValidarPermissaoFuncionalidadeService,
    ) {
        this.sistemasListaAgrupados$ = store.pipe(select('sistemasLista'));

    }


    ngOnInit() {

        if(isDevMode()){
            console.log("DEVELOPER");
        }else{
            console.log("PRODUCTION");
        }

        this.loginService.mostrarLoginInputEmitter.subscribe((mostrar: Boolean) => this.mostrarLoginInput = mostrar);

        this._mostrarMenuQuandoLogado();

        if (this.authInterceptor.getJwtCdCentrus()) {this.checkTokenAndSistem()};

    }

    // setCookie(key, value, expiry) {
    //     var expires = new Date();
    //     expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    //     document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
    // }

    ngAfterContentChecked(): void {
        const url = this.router.url;
       if (url === '/login' && this.mostrarMenu) { this.loginService.logout()};
    }


    private _mostrarMenuQuandoLogado(): void {
        this.loginService.mostrarMenuEmitter
            .subscribe((mostrar) => {
                this.mostrarMenu = mostrar;
                this.layoutStatic = false;
                if (mostrar) {
                    this.checkTokenAndSistem();
                }
            }
            );

    }

    checkTokenAndSistem() {
        const tokenInvalid = this.authInterceptor.tokenInvalid();
        this.store.dispatch(new ItemMenuActions.ClearItemMenu(null));

        if (tokenInvalid || !localStorage.getItem(TOKEN_PADRAO)) {
            this.loginService.esconderMenu();
            this.mostrarMenu = false
            return false;
        }

        if (!tokenInvalid) {
            this.mostrarMenu = true;
            this.getSistemasLista();
            this.validarPermissaoFuncionalidadeService.getSistemaByCdCentrusTpSistemaSgSistema();
        }

    }

    getSistemasLista() { this.sistemasListaAgrupados$.subscribe((arg) => this.sistemasLista = arg); }


    clickMenu() {
        if (!this.menuClick && !this.menuButtonClick)  {this.mobileMenuActive = false};
        this.menuClick = false;
        this.menuButtonClick = false;
    }

    onMenuButtonClick(evento) {
        this.mobileMenuActive = evento.mobileMenuAtivo;
        this.menuButtonClick = evento.menuButtonClick;
    }

    onSidebarClick(event) {
        this.menuClick = event.menuClickAction;
    }

    onToggleMenuClick(event) {
        this.layoutStatic = event.layoutStatic;
    }




}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.component.ts